import { createAction, props } from '@ngrx/store';
import { User } from '@shared/models/interfaces/user.interface';

import * as ActionTypes from './user.actionTypes';

export const loadUser = createAction(ActionTypes.LOAD_USER, props<{ user: User }>());
